import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FallbackImagesService {

  constructor() { }

  public getAvatar(url: string) {
    return url ? url : '/assets/fallback-images/default-avatar.png';
  }
}
